export enum StepDirection {
  Beginning = 'beginning',
  Next = 'next',
  Previous = 'previous',
  MoveFlow = 'move-flow',
  StayHere = 'stay-here',
  ApiResponse = 'api-response',
  NextIfStepMatches = 'next-if-step-matches',
}
